'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.option = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _normal = require('./_normal.scss');

var _normal2 = _interopRequireDefault(_normal);

var _Divider = require('./../../molecules/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _reactCssThemr = require('react-css-themr');

var _limitedWidth = require('../../hoc/limitedWidth');

var _limitedWidth2 = _interopRequireDefault(_limitedWidth);

var _Boxed = require('../../hoc/Boxed');

var _Boxed2 = _interopRequireDefault(_Boxed);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import questionOptions from 'lemon-db/dist/options/question.json';
// import explicitChildren from '../../util/explicitChildren';
// hocs
// export const options = questionOptions;


var option = exports.option = {};

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      TextEditor = _ref.TextEditor;

  var Question = function (_React$Component) {
    _inherits(Question, _React$Component);

    function Question(props) {
      _classCallCheck(this, Question);

      var _this = _possibleConstructorReturn(this, (Question.__proto__ || Object.getPrototypeOf(Question)).call(this, props));

      _this.renderMediaAnswers = function () {
        var _this$props = _this.props,
            children = _this$props.children,
            theme = _this$props.theme;
        return _react2['default'].createElement('div', {
          className: theme.mediaAnswerWrapper
        }, _react2['default'].Children.map(children, function (answer) {
          return _react2['default'].createElement('div', {
            className: theme.mediaAnswer
          }, answer);
        }));
      };

      _this.renderPlainChildren = function () {
        return _this.props.children;
      };

      _this.questionTypes = {
        media: _this.renderMediaAnswers,
        text: _this.renderPlainChildren,
        form: _this.renderPlainChildren
      };
      return _this;
    }

    _createClass(Question, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            type = _props.type,
            draft = _props.draft,
            color = _props.color,
            align = _props.align,
            rest = _objectWithoutProperties(_props, ['type', 'draft', 'color', 'align']);

        return _react2['default'].createElement('div', null, draft && _react2['default'].createElement(TextEditor, _extends({
          draft: draft,
          color: color,
          align: align
        }, rest, {
          boxed: false
        })), _react2['default'].createElement(_Divider2['default'], {
          hidden: true
        }), _react2['default'].createElement('div', null, this.questionTypes[type]()));
      }
    }]);

    return Question;
  }(_react2['default'].Component);

  Question.displayName = identifier;
  Question.themeShape = {
    mediaAnswer: _propTypes2['default'].string.isRequired
  };
  Question.propTypes = {
    type: _propTypes2['default'].oneOf(['media', 'text', 'form']).isRequired,
    children: _propTypes2['default'].any,
    theme: _propTypes2['default'].shape(Question.themeShape),
    draft: _propTypes2['default'].object,
    color: _propTypes2['default'].string,
    align: _propTypes2['default'].oneOf(['center', 'left']),
    isResponsive: _propTypes2['default'].bool,
    hasBoxedText: _propTypes2['default'].bool
  };
  Question.defaultProps = {
    align: 'center',
    color: 'black',
    isResponsive: true,
    box: {
      top: 'large',
      bottom: 'large',
      left: 'medium',
      right: 'medium'
    }
  };
  var themed = (0, _reactCssThemr.themr)(identifier, _normal2['default'])(Question);
  var limited = (0, _limitedWidth2['default'])(themed, 'button');
  return (0, _Boxed2['default'])(true)(limited);
};

exports['default'] = factory;